/// <reference path="Utilities/_reference.ts" />

module YVR.RestaurantMenu {
	// Dependencies
	import logger = YVR.Utilities.Logger;
	import i18n = YVR.Utilities.I18n;

	
	//main function
	function main() {

		if (window.location.href.indexOf("dine-shop-and-services") > -1 || window.location.href.indexOf("shop-dine-and-services") > -1) {

			console.log("loading menus and features")

			if ($('.yvr-featured-dishes').length > 0) {
				initFeaturedDealsSwiper();
			}

			if ($('.yvr-restaurant-menu').length > 0) {
				initPrimaryMenuSlick($('.tab__list.primary'));
				initSecondaryMenuSlick($('.tab__list.secondary'));
				legendEventBinding();
			}
		}

	}



	const tabs = document.querySelectorAll(".tab");

	function tabify(tab) {
		const tabList = tab.querySelector(".tab__list");

		if (tabList) {
			const tabItems = [...tabList.children];
			const tabContent = tab.querySelector(".tab__content");
			const tabContentItems = [...tabContent.children];
			let tabIndex = 0;

			tabIndex = tabItems.findIndex((item, index) => {
				return [...item.classList].indexOf("is--active") > -1;
			});

			tabIndex > -1 ? (tabIndex = tabIndex) : (tabIndex = 0);

			function setTab(index) {
				tabItems.forEach((x, index) => x.classList.remove("is--active"));
				tabContentItems.forEach((x, index) => x.classList.remove("is--active"));

				tabItems[index].classList.add("is--active");
				tabContentItems[index].classList.add("is--active");
			}

			tabItems.forEach((x, index) =>
				x.addEventListener("click", () => setTab(index))
			);
			setTab(tabIndex);
			tab.querySelectorAll(".tab").forEach((tabContent) => tabify(tabContent));
		}
	}

	tabs.forEach(tabify);

	function initFeaturedDealsSwiper() {

		var swiper = new Swiper(".mySwiper", {
			pagination: {
				el: ".swiper-pagination",
				type: "fraction",
				renderFraction: function (currentClass, totalClass) {
					return '<span class="font-14 font-light-blue ' + currentClass + '"></span>' +
						'<span class="font-14 font-light-blue">  of </span> ' +
						'<span class="font-14 font-light-blue ' + totalClass + '"></span>';
				}
			},
			navigation: {
				nextEl: ".swiper-button-next",
				prevEl: ".swiper-button-prev",
			},
			loop: true
		});

	}

	function isOverflown(element) {
		//console.log(element);

		return element.scrollWidth > element.clientWidth;
	}

	function initPrimaryMenuSlick(element) {

		//console.log('init primary menu');

		//there should only be one primary menu
		var primaryMenu = element[0];

		//if it overflows, slick it to give it buttons etc
		if (isOverflown(primaryMenu)) {
			element.slick({
				variableWidth: true,
				infinite: false,
			});

			element.on('afterChange', function (e, slick) {

				let lastElement = slick.$slides[slick.slideCount - 1];
				let lastElementRect = lastElement.getBoundingClientRect();
				let lastElementOffset = lastElementRect.x + lastElementRect.width;

				let fullSlick = $('.slick-list', element)[0];
				let fullSlickRect = fullSlick.getBoundingClientRect();
				let fullSlickOffset = fullSlickRect.x + fullSlickRect.width;

				if (lastElementOffset < fullSlickOffset) {
					$('.slick-next', element).addClass('slick-disabled');
				}
			});


		}
	}

	function initSecondaryMenuSlick(element) {

		//console.log('init secondary menu');

		element.each(function (index, obj) {
			if (isOverflown(obj)) {
				$(obj).slick({
					variableWidth: true,
					infinite: false
				});

				$(obj).on('afterChange', function (e, slick) {

					let lastElement = slick.$slides[slick.slideCount - 1];
					let lastElementRect = lastElement.getBoundingClientRect();
					let lastElementOffset = lastElementRect.x + lastElementRect.width;

					let fullSlick = $('.slick-list', $(obj))[0];
					let fullSlickRect = fullSlick.getBoundingClientRect();
					let fullSlickOffset = fullSlickRect.x + fullSlickRect.width;

					if (lastElementOffset < fullSlickOffset) {
						$('.slick-next', $(obj)).addClass('slick-disabled');
					}
				});
			}

		});

		let tabItem = $('.tab__content-item');
		tabItem.addClass('display-none');

	}



	function legendEventBinding() {
		// JavaScript to toggle the legend's visibility
		const toggleButton = document.getElementById('toggleButton');
		const legendContainer = document.getElementById('legend-container');

		let button = $('.button');
		let legendIcon = $('.legend-icon');
		let legendIconActive = $('.legend-icon-active');


		toggleButton.addEventListener('click', () => {
			legendContainer.style.display = legendContainer.style.display === 'none' ? 'block' : 'none';

			button.toggleClass('active');
			legendIcon.toggleClass('hide');
			legendIconActive.toggleClass('hide');
		});

	}
	
	main();
}
